// extracted by mini-css-extract-plugin
export var addButton = "_dj-4";
export var contentBlockImage = "_dj-i";
export var contentBlockWidgetPreview = "_dj-g";
export var fulfillmentCutoffWidgetPreview = "_dj-9";
export var imageBackdrop = "_dj-6";
export var imageIcon = "_dj-8";
export var lowProfileImageContainer = "_dj-b";
export var lowProfileImageIcon = "_dj-f";
export var lowProfileImageIconContainer = "_dj-e";
export var lowProfileImagePlaceholder = "_dj-d";
export var lowProfileProductImage = "_dj-c";
export var lowProfileProductUpsellWidgetPreview = "_dj-a";
export var productCard = "_dj-5";
export var productImage = "_dj-7";
export var productReviewsWidgetPreview = "_dj-h";
export var progressBar = "_dj-1";
export var progressBarFill = "_dj-2";
export var progressBarTrack = "_dj-3";
export var shippingOptionWidgetPreview = "_dj-j";
export var shippingUpsellProgressBar = "_dj-k";
export var thresholdUpsellWidgetPreview = "_dj-0";